import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals }) {


  // console.log("Grand Total", totals);
  const parseAmount = (value) => {
    if (value == null) return 0;

    let str = String(value).replace(/,/g, "").trim();

    // Handle trailing minus
    if (str.endsWith("-")) {
      str = "-" + str.slice(0, -1);
    }

    return Number(str) || 0;
  };


  const totalLabour =
    Number(totals[0]["DIRECT LABOUR"] || 0) +
    Number(totals[0]["ON COST LABOUR"] || 0);

  const totalStore =
    Number(totals[0]["ON COST STORE"] || 0) +
    Number(totals[0]["DIRECT STORE"] || 0);


  const freight =
    totalStore * (Number(totals[0]["StoreFreight"] || 0) / 100);

  const proforma =
    totalLabour * (Number(totals[0]["proformaoncost"] || 0) / 100);


   
  let total = freight + proforma;




  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >


      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mb: 20, px: 2 }}
      >





        <Grid size={{ xs: 12, md: 4 }} >

          <TableContainer
            component={Paper}
            variant="outlined"
           
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    //colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    Description
                  </TableCell>

                  <TableCell
                    // colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>


                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      Freight + Proforma
                    </Typography>

                  </TableCell>


                  <TableCell align="right">
                    <CurrencyCell value={total} />
                  </TableCell>

                </TableRow>




              </TableBody>
            </Table>
          </TableContainer>

        </Grid>



      </Grid>
    </Paper>
  );
}